/// <summary>
/// This object provides client-side functions for an process step wizard similar to a breadcrum <br/>
/// An html div can get instanciated as wizard when it has the following structure:<br/>
/// <div class='vc-wizard'><div class='vc-wizard-step'>step 1</div><div class='vc-wizard-step'>step 2</div>...</div><br/>
/// The instanciation in js:<br/>
/// $(".vc-wizard").vcWizard();<br/>
/// Per default the 1st step (index=0) is set as active - to change the active step use<br/>
/// $(".vc-zwizard").vcWizard("setActive", index);<br/>
/// further methods are<br/>
/// $(".vc-wizard").vcWizard("getActive") - returns the active index or -1 on error<br/>
/// $(".vc-wizard").vcWizard("getLength") - returns the number of steps<br/>
/// <br/>
/// Change the default step width by the following option: <br/>
/// $(".vc-wizard").vcWizard({stepWidth:newWidth});<br/>
/// <br/>
/// Author: AFU<br />
/// Date: 14.11.2016<br />
/// Copyright ©: EUDT GmbH 2016 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 14.06.2016                                               *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>
$.widget("bluaul.vcWizard",
{



    // Default options.
    options: {
        stepWidth: 280,
        errorText: ""
    },
    steps: {},

    _create: function () {
        var me = this;
        //add the wizard class to the given div
        if (this.element.hasClass("vc-wizard") === false) { this.element.addClass("vc-wizard"); }
        //store the single steps
        this.steps = this.element.find(".vc-wizard-step");
        
        //iterate through all steps    
        this.steps.each(function (index) {
            if ($(this).hasClass("step" + index) === false) {
                $(this).addClass("step" + index);
            }
            //set the given width for each step
            me.steps.width(me.options.stepWidth);
            //set the first step as active and all other steps as open
            if (index === 0) {
                me.setActive(index);
            } else {
                me._setOpen(index);
            }
        });

    },
    //sets all steps lower than the given index as done and all higher as open
    setActive: function (index) {
        var i;
        var maxLen = parseInt(this.element.find(".vc-wizard-step").length, 10);
        for (i = 0; i < index; i++) { this._setDone(i); }

        if (index < maxLen) {
            for (i = index + 1; i < maxLen; i++) { this._setOpen(i); }
        }
        this._clear(index);
        this.element.find(".step" + index).addClass("active color-border-primary color-bg-primary");
    },
    //returns the index of the active step or -1 on error
    getActive: function () {
        for (var i = 0; i < parseInt(this.element.find(".vc-wizard-step").length, 10) ; i++) {
            if (this.element.find(".step" + i).hasClass("active")) {
                return i;
            }
        }
        return -1;
    },
    //returns the number of steps
    getLength: function () {
        return parseInt(this.element.data("max-steps", 10));
    },
    //states that the step contains invalid values
    setInvalid: function (index) {
        if(this.getValidState(index)===true)
            this.element.find(".step" + index).prepend("<i class='fa fa-exclamation-triangle  fa-lg vc-wizard-error' title='" + this.options.errorText + "'></i> ");
    },
    //states that the step is valid
    setValid: function(index) {
        this.element.find(".step" + index + " .vc-wizard-error").remove(); 

    },
    //returns whether the step is valid
    getValidState: function (index) {
        return this.element.find(".step" + index + " .vc-wizard-error").length === 0; 

    },
    //the step is set as not yet reached
    _setOpen: function (index) {
        this._clear(index);
        this.element.find(".step" + index).addClass("open color-border-secondary color-bg-secondary");
    },
    //the step is already reached
    _setDone: function (index) {
        this._clear(index);
        this.element.find(".step" + index).addClass("done color-border-primary color-bg-primary");
    },
    //removes all styles from the step
    _clear: function (index) {
        this.element.find(".step" + index).removeClass("open done active color-border-primary color-bg-primary color-border-secondary color-bg-secondary ");
    }



});
